module.exports = __webpack_public_path__ + "static/in-app-trading-static-e85d3e6257948e589ab93a6b4ac2f9e3.png";